// extracted by mini-css-extract-plugin
export default {"stepIndicator":"UiStepperStep_stepIndicator_VwIad"};